import { withForm } from "~/components/form/app-form";
import { Card, CardContent, CardHeader, CardTitle } from "~/components/ui/card";

import { offerFormOptions } from "../offer-form-options";

export const ResultsSection = withForm({
  ...offerFormOptions,
  render: function Render({ form }) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Results from following this program</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <form.AppField name="resultsPreHeadline">
            {(field) => <field.TextField label="Results Pre-Headline" />}
          </form.AppField>

          <form.AppField name="resultsHeadline">
            {(field) => <field.TextField label="Results Headline" />}
          </form.AppField>

          <form.AppField name="resultsDescription">
            {(field) => (
              <field.TextareaField label="Description" maxLength={500} />
            )}
          </form.AppField>

          <form.AppField name="resultsImageUrl">
            {(field) => (
              <field.ImageField
                purpose="offer"
                label="Image"
                recommendedDimensions={{ width: 600, height: 400 }}
              />
            )}
          </form.AppField>
        </CardContent>
      </Card>
    );
  },
});
